var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToSignCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 105,
    viewBox: "0 0 137 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_toSignCompleted)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.078 12.074a.376.376 0 00-.376.374s0 0 0 0l-.202 87.99s0 0 0 0a.375.375 0 00.374.376s0 0 0 0m.204-88.74l-.205 89.24.001-.5m.204-88.74s0 0 0 0l69.797.16s0 0 0 0a.375.375 0 01.374.376l-70.17-.536zm-.204 88.74l69.797.161-69.797-.161zm70.173-.214v.001a.375.375 0 01-.376.374l.876-.373-.5-.002zm0 0l.202-87.99-.202 87.99z",
    fill: "#fff",
    stroke: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.605 49.783l-51.43-.118a1.313 1.313 0 11.006-2.624l51.43.118a1.312 1.312 0 01-.006 2.624zm.498-24.445l-34.12-.079c-.481-.001-.87-.59-.868-1.314.002-.724.393-1.311.874-1.31l34.12.079c.48 0 .869.59.867 1.314-.002.724-.392 1.31-.873 1.31zm-.017 7.522l-34.12-.079c-.48-.001-.869-.59-.867-1.314.001-.724.392-1.311.873-1.31l34.12.079c.48 0 .87.589.868 1.314-.002.724-.393 1.31-.874 1.31zm-.5 25.407l-51.43-.118a1.312 1.312 0 01.006-2.624l51.43.119a1.312 1.312 0 01-.006 2.623zm-.02 8.485l-51.43-.119a1.311 1.311 0 11.006-2.624l51.43.119a1.311 1.311 0 11-.006 2.624zm-.019 8.484l-51.43-.119a1.312 1.312 0 01.007-2.624l51.43.119a1.312 1.312 0 01-.007 2.624zm-.02 8.484l-51.43-.118a1.312 1.312 0 01.006-2.624l51.43.118a1.312 1.312 0 01-.006 2.624zm-.02 8.484l-51.43-.118a1.31 1.31 0 01-1.308-1.316 1.312 1.312 0 011.315-1.308l51.43.118a1.313 1.313 0 11-.007 2.624z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.824 34.677a6.91 6.91 0 100-13.82 6.91 6.91 0 000 13.82z",
    fill: "var(--color-secondary-light)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.534 21.702l11.921 14.163 4.321-3.636-1.325-1.574 2.16-1.818-9.272-11.016-2.16 1.818-1.325-1.574-4.32 3.637z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.731 53.864l14.798-12.456c-.985-2.067-1.159-3.19-.549-4.416a5.328 5.328 0 012.547-2.448c1.219-.569 2.163-.523 3.598.556a7.691 7.691 0 012.027 2.264c1.231 2.125.956 4.018-.858 5.544-1.736 1.462-3.235 1.55-5.373.121l-2.78 2.34L93.104 55.64l29.611-1.196s-.774-10.705 6.484-20.97l-9.51-11.298s-13.666 5.69-21.104 2.252L91.73 53.864z",
    fill: "var(--color-secondary-light)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.242 53.007l13.733-11.559c-.75-1.213-1.076-2.605-.918-3.915.158-1.31.789-2.448 1.776-3.202.986-.754 2.26-1.071 3.583-.892 1.323.178 2.605.84 3.604 1.862.999 1.022 1.648 2.334 1.825 3.689.177 1.355-.13 2.661-.864 3.674-.733 1.012-1.843 1.662-3.121 1.826-1.279.165-2.637-.167-3.822-.933l-13.901 11.7 27.67-1.49s-.476-11.137 6.745-21.062l-8.214-9.758s-14.229 5.567-21.253 2.503l-6.843 27.557z",
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.008 21.101l8.844 10.507 3.255-2.74-8.843-10.507-3.256 2.74z",
    fill: "var(--color-primary)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.141 21.792l11.37 13.509 3.907-3.289-11.37-13.508-3.907 3.288z",
    fill: "var(--color-primary)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.141 21.792l11.37 13.509 3.907-3.289-11.37-13.508-3.907 3.288z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-primary)",
    d: "M125.527 19.165l11.756-9.84 6.969 8.327-11.756 9.84z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.501 75.087L93.933 91.522a1.102 1.102 0 01-1.557-.007l-7.884-7.947a1.101 1.101 0 01.007-1.557l.782-.776a1.102 1.102 0 011.557.006l6.332 6.383 15.004-14.883a1.1 1.1 0 011.557.006l.776.782a1.1 1.1 0 01-.006 1.558z",
    fill: "#49BC74"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 128.975,
    y1: 23.329,
    x2: 122.494,
    y2: 28.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_toSignCompleted"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h137v104.51H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToSignCompleted);
export default __webpack_public_path__ + "static/media/toSignCompleted.c700f7925d091975becb01cbedfbed77.svg";
export { ForwardRef as ReactComponent };